import type { GridRowSelectionModel } from '@mui/x-data-grid-pro';
import type { SiteMeta } from '@src/types/SiteMeta';
import type { WidgetTypeDeviceList } from '@src/types/Widget';
import type { TimeMode } from '@types';

export const TEMPERATURE_THRESHOLDS = {
  INCIDENT: 40,
  WARNING: 60,
  CRITICAL: 70,
} as const;

export type DataSource = 'historian' | 'mqtt' | 'alerts';

export type ConnectionStatus = 'connected' | 'disconnected' | 'reconnecting';

export interface Incident {
  readonly id: string;
  deviceName: string;
  rackId: string;
  maxCellT: number;
  timestamp: string;
  unitId: string;
  isRealTime?: boolean;
  dataSource?: DataSource;
  mqttTopic?: string;
}

export interface IncidentMaxCellTMonitorProps {
  widgetConfig?: WidgetTypeDeviceList;
  selectedUnits?: GridRowSelectionModel;
  siteMeta: SiteMeta;
  timeMode: TimeMode;
}
